var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _vm.error.length > 0 ? _c('el-alert', { staticClass: "alert-message", attrs: { "title": "警告信息", "type": "warning", "closable": false } }, _vm._l(_vm.error, function (item, index) {
    return _c('p', { key: index }, [_vm._v("\n    " + _vm._s(item.message) + "\n  ")]);
  }), 0) : _vm._e();
};
var staticRenderFns = [];

export { render, staticRenderFns };